import { cn } from '@/lib/utils';
interface TrustPilotStarProps {
  className?: string;
  emptyBackgroundColor?: string;
  emptyForegroundColor?: string;
  filledBackgroundColor?: string;
  filledForegroundColor?: string;
  hasBackground?: boolean;
  isFilled?: true | false | 'half';
}
export const TrustPilotStar = ({
  className = '',
  emptyBackgroundColor = '#DCDCE6',
  emptyForegroundColor = '#FFF',
  filledBackgroundColor = '#00B67A',
  filledForegroundColor = '#FFF',
  hasBackground = true,
  isFilled = true
}: TrustPilotStarProps) => {
  const CSSVariables = {
    '--filled-foreground-color': filledForegroundColor,
    '--filled-background-color': filledBackgroundColor,
    '--empty-foreground-color': emptyForegroundColor,
    '--empty-background-color': emptyBackgroundColor
  } as React.CSSProperties;
  if (isFilled === 'half') {
    return <svg aria-hidden="true" className={cn('size-5 2xl:size-6', className)} fill="none" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg" style={CSSVariables}>
        {!!hasBackground && <>
            <path d="M0 46H23V0H0V46Z" className="fill-(--filled-background-color)" />
            <path d="M23 46H46V0H23V46Z" className="fill-(--empty-background-color)" />
          </>}
        <path d="M39.5339 19.7115L13.2302 38.8007L17.0685 27.0029L7.02115 19.7115H19.4401L23.2775 7.91284L27.115 19.7115H39.5339ZM23.2785 31.5101L30.4621 30.0005L33.3242 38.8007L23.2785 31.5101Z" className="fill-(--filled-foreground-color)" />
      </svg>;
  }
  return <svg aria-hidden="true" className={cn('size-5 2xl:size-6', className)} viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg" style={CSSVariables} data-sentry-element="svg" data-sentry-component="TrustPilotStar" data-sentry-source-file="TrustPilotStar.tsx">
      {!!hasBackground && <path d="M0 46.330002h46.375586V0H0z" className={cn(isFilled ? 'fill-(--filled-background-color)' : 'fill-(--empty-background-color)')} />}
      <path d="M39.5339 19.7115L13.2302 38.8007L17.0685 27.0029L7.02115 19.7115H19.4401L23.2775 7.91284L27.115 19.7115H39.5339ZM23.2785 31.5101L30.4621 30.0005L33.3242 38.8007L23.2785 31.5101Z" className={cn(isFilled ? 'fill-(--filled-foreground-color)' : 'fill-(--empty-foreground-color)')} data-sentry-element="path" data-sentry-source-file="TrustPilotStar.tsx" />
    </svg>;
};